import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class ProductStatusForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'udgivelse-status', dataApiName: 'ProductStatus', text: 'Udgivelesstatus', textSingular: 'Udgivelesstatus',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      },
      fieldMetadata: [
        { name: 'publishingStatus', text: 'Udgivelsesstatus', fieldType: 'productPublishingStatus' },
        { name: 'marketAvailability', text: 'Tilgængelighed', fieldType: 'productMarketAvailability' },
        { name: 'publishingStatusInternal', text: 'Udgivelsesstatus interne', fieldType: 'productPublishingStatus' },
        { name: 'marketAvailabilityInternal', text: 'Tilgængelighed interne', fieldType: 'productMarketAvailability' }
      ]
    });
  }
}
